import { CommentInput, PublicUserProfile, UserProfile } from 'api';
import { getFullName } from 'helpers';

interface ICreateCommentResponse {
  commentInput: CommentInput;
  user: UserProfile;
  mentionedUsers: PublicUserProfile[];
}

export const createCommentResponse = ({
  commentInput,
  user,
  mentionedUsers,
}: ICreateCommentResponse) => ({
  createComment: {
    ...commentInput,
    id: -1,
    user: {
      id: user.id,
      full_name: getFullName(user),
      __typename: 'PublicUserProfile',
    },
    users_mentioned: mentionedUsers,
    has_substitutions: !!mentionedUsers.length,
    __typename: 'Comment',
  },
});
